import ChatComponent from "../../lib/ChatComponent";

const Attivita = ({ idUID, fetchMessages }) => {
  return (
    <div>
      <ChatComponent idUID={idUID} fetchMessages={fetchMessages} />
    </div>
  );
};

export default Attivita;
